import { ArrowUpRight, Clock } from "lucide-react";
import { toast } from "sonner";
import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

const IMAGES = [
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=70",
  "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?auto=format&fit=crop&w=1200&q=70",
];

export const Insights = () => {
  const t = useT();

  const handleClick = (e, item) => {
    e.preventDefault();
    toast(t.insights.comingSoon, {
      description: t.insights.comingSoonDesc,
    });
  };

  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
                {t.insights.eyebrow}
              </p>
            </Reveal>
            <Reveal delay={60}>
              <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
                {t.insights.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={120}>
            <p className="max-w-md text-base text-slate-600 leading-relaxed">
              {t.insights.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {t.insights.items.map((p, i) => (
            <Reveal key={p.title} delay={70 * i}>
              <article
                data-testid={`insight-card-${i}`}
                className="group h-full flex flex-col bg-white rounded-2xl border border-slate-200/70 overflow-hidden uv-card-hover"
              >
                <div className="relative uv-img-zoom aspect-[16/10] bg-slate-100 overflow-hidden">
                  <img
                    src={IMAGES[i]}
                    alt={p.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center rounded-full bg-white/95 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[#2563EB]">
                    {p.category}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-6">
                  <div className="flex items-center gap-3 text-xs font-medium text-slate-500">
                    <span>{p.date}</span>
                    <span className="w-1 h-1 rounded-full bg-slate-300" aria-hidden="true" />
                    <span className="inline-flex items-center gap-1">
                      <Clock className="w-3.5 h-3.5" />
                      {p.readTime}
                    </span>
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-[#0A2342] leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
                    {p.excerpt}
                  </p>
                  <a
                    href="#insights"
                    onClick={(e) => handleClick(e, p)}
                    data-testid={`insight-cta-${i}`}
                    className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563EB] hover:text-[#1D4ED8] hover:gap-2 transition-all"
                  >
                    {t.insights.readMore}
                    <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Insights;
